import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const Footer = () => {
  return (
    <footer className="bg-light text-center text-sm-start mt-auto fixed-bottom">
      <hr />
      <div className="container d-flex justify-content-between align-items-center py-3">
        {/* Left Side: Company Icon and Copyright */}
        <div className="d-flex align-items-center">
          <img src="https://jmeter.apache.org/images/mstile-144x144.png" alt="Company Icon" width="50" height="50" className="me-2" />
          <span>© 2024 Company, Inc</span>
        </div>
        
        {/* Right Side: Social Media Icons */}
        <div className="d-flex">
          <a href="#" className="text-dark me-3" aria-label="Facebook">
            <i className="bi bi-facebook"></i>
          </a>
          <a href="#" className="text-dark me-3" aria-label="Twitter">
            <i className="bi bi-twitter"></i>
          </a>
          <a href="#" className="text-dark me-3" aria-label="Instagram">
            <i className="bi bi-instagram"></i>
          </a>
          <a href="#" className="text-dark" aria-label="LinkedIn">
            <i className="bi bi-linkedin"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
